import React from 'react'
import { Route, Navigate, Routes as ReactRouterRoutes } from 'react-router-dom'
import Home from '../components/home/Home'
import FormRoot from '../components/form/FormRoot'
import ApplicationClaimKey from '../components/prepopulate/ApplicationClaimKey'
import PinVerification from '../components/pin/PinVerification'
import BenAdminIntegrationTesting from '../components/benadmin/BenAdminIntegrationTesting'
import Decision from '../components/submission/Decision'

export default function Routes ({ formReadyToBegin }) {
  return <ReactRouterRoutes>
    <Route path='/' element={<Navigate to='/home' />} />
    <Route path='/home' element={<Home />} />
    <Route path='/form' element={formReadyToBegin ? <FormRoot /> : <Navigate to='/home' />} />
    <Route path='/application' element={<ApplicationClaimKey />} />
    <Route path='/pin-verification' element={<PinVerification />} />
    <Route path='/ben-admin-integration-testing' element={<BenAdminIntegrationTesting />} />
    <Route path='/thank-you' element={formReadyToBegin ? <Decision /> : <Navigate to='/home' />} />
    <Route element={<Navigate to='/home' />} />
  </ReactRouterRoutes>
}